import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { hasAnyRole, getDashboardRoute } from "../../utils/roleUtils";

interface RoleGuardProps {
  children: React.ReactNode;
  allowedRoles: string[];
  fallbackRoute?: string;
}

const RoleGuard: React.FC<RoleGuardProps> = ({
  children,
  allowedRoles,
  fallbackRoute,
}) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="loading loading-spinner loading-lg"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has any of the allowed roles
  if (!hasAnyRole(user, allowedRoles)) {
    // Redirect to user's appropriate dashboard or specified fallback
    const redirectRoute = fallbackRoute || getDashboardRoute(user);
    return <Navigate to={redirectRoute} replace />;
  }

  return <>{children}</>;
};

export default RoleGuard;
